// ---------------------------------------------------------------
// Copyright (c) Aspen Publishing. All rights reserved.
// ---------------------------------------------------------------

const CartRemoveButton = class extends HTMLElement {
  connectedCallback() {
    const link = this.querySelector('a');

    if (link) {
      link.addEventListener('click', event => {
        try {
          event.preventDefault();
          this.dataset.testing = 'testing';
          let { key, sections, sections_url } = link.dataset;

          if (!key || !sections || !sections_url) {
            return;
          }

          sections = [sections];

          const cartComponents = this.closest('cart-component,cart-drawer-component');

          if (!cartComponents) {
            return;
          }

          cartComponents.dispatchEvent(
            new CustomEvent('change', {
              bubbles: true,
              detail: {
                customElement: {
                  target: link,
                  key,
                  quantity: 0,
                  sections,
                  sections_url,
                },
              },
            })
          );

          let popup = document.querySelector('#popup-confirm-remove');

          if (!popup) {
            return;
          }

          popup.style.display = 'none';
          document.body.classList.remove('show-popup');
        } catch (error) {
          console.error('Error in cart-remove-button:', error);
        }
      });
    }
  }
};

if (!customElements.get('cart-remove-button')) {
  customElements.define('cart-remove-button', CartRemoveButton);
}
